import React from "react";
import CoursesList from "@/components/student/CoursesList";
import { useSearchParams } from "@/src/lib/next-compat";

export default function CoursesPage() {
  const searchParams = useSearchParams();
  const page = searchParams.get("page");
  const limit = searchParams.get("limit");

  const parsedPage = page ? Number.parseInt(page, 10) : 1;
  const parsedLimit = limit ? Number.parseInt(limit, 10) : 12;
  const pageNum = Number.isNaN(parsedPage) || parsedPage < 1 ? 1 : parsedPage;
  const limitNum = Number.isNaN(parsedLimit) || parsedLimit < 1 ? 12 : Math.min(parsedLimit, 50);
  const cacheKey = `courses:${pageNum}:${limitNum}`;

  return <CoursesList page={pageNum} limit={limitNum} cacheKey={cacheKey} />;
}
